import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from './NavBar';
import Header from './Header';
import PushPermissionPrompt from './PushPermissionPrompt';
const Layout = ({ children, title, icon, showBackButton = true, onBack, noBottomPadding = false }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = React.useState(
    typeof window !== 'undefined' ? window.innerWidth < 900 : false
  );
  const [navbarHeight, setNavbarHeight] = React.useState(80);
  const [mounted, setMounted] = React.useState(false);
  const user = mounted ? JSON.parse(localStorage.getItem('user') || 'null') : null;

  React.useEffect(() => {
    setMounted(true);
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 900);
      const nav = document.querySelector('nav');
      if (nav) setNavbarHeight(nav.offsetHeight || 60);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    window.addEventListener('orientationchange', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('orientationchange', checkMobile);
    };
  }, []);

  const handleGoBack = () => {
    if (onBack) {
      onBack();
    } else {
      window.history.back();
    }
  };

  if (!mounted) return null;

  return (
    <div style={isMobile ? {
      ...styles.mobileContainer,
      paddingBottom: noBottomPadding ? 0 : `${navbarHeight}px`
    } : styles.desktopContainer}>
      
      <Header 
        title={title} 
        icon={icon} 
        onBack={showBackButton ? handleGoBack : null}
      />

      <div style={isMobile ? styles.mobileContent : styles.desktopContent}>
        {children}
      </div>

      {isMobile && (
        <>
          {user && <NavBar />}    
          <PushPermissionPrompt />    
        </>
      )}
    </div>
  );
};

const styles = {
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100dvh',
    backgroundColor: '#F0F3FF',
    overflow: 'hidden',
    boxSizing: 'border-box'
  },
  mobileContent: {
    flex: 1,
    overflowY: 'auto',
    padding: '16px',
    WebkitOverflowScrolling: 'touch',
    width: '100%'
  },
  desktopContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    backgroundColor: '#F0F3FF',
    overflow: 'hidden'
  },
  desktopContent: {
    flex: 1,
    overflowY: 'auto',
    padding: '16px',
    width: '100%'
  }
};

export default Layout;